module.exports = __webpack_public_path__ + "img/10979917_L.3b19cbcd.png";